var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1772Plug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11589_6343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5 3.53535C52.8232 3.53535 66.9646 17.6768 66.9646 35C66.9646 52.3232 52.8232 66.4646 35.5 66.4646C18.1768 66.4646 4.03535 52.3232 4.03535 35C4.03535 17.6768 18.1768 3.53535 35.5 3.53535ZM35.5 0C16.0556 0 0.5 15.5556 0.5 35C0.5 54.4444 16.0556 70 35.5 70C54.9444 70 70.5 54.4444 70.5 35C70.5 15.5556 54.9444 0 35.5 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.637 48.6109C21.3705 48.6109 23.5865 46.3949 23.5865 43.6614C23.5865 40.9279 21.3705 38.7119 18.637 38.7119C15.9035 38.7119 13.6875 40.9279 13.6875 43.6614C13.6875 46.3949 15.9035 48.6109 18.637 48.6109Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3987 48.6109C55.1322 48.6109 57.3482 46.3949 57.3482 43.6614C57.3482 40.9279 55.1322 38.7119 52.3987 38.7119C49.6652 38.7119 47.4492 40.9279 47.4492 43.6614C47.4492 46.3949 49.6652 48.6109 52.3987 48.6109Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0557 16.5986C25.8965 16.5986 28.2 18.9014 28.2002 21.7422C28.2002 24.5831 25.8966 26.8867 23.0557 26.8867C20.2149 26.8865 17.9121 24.583 17.9121 21.7422C17.9123 18.9016 20.2151 16.5988 23.0557 16.5986Z",
    stroke: "#F0F0F0",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.499 47.7095C38.3398 47.7095 40.6433 50.0123 40.6436 52.853C40.6436 55.6939 38.3399 57.9976 35.499 57.9976C32.6583 57.9974 30.3555 55.6938 30.3555 52.853C30.3557 50.0124 32.6584 47.7097 35.499 47.7095Z",
    stroke: "#F0F0F0",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9795 16.5986C50.8203 16.5986 53.1238 18.9014 53.124 21.7422C53.124 24.5831 50.8204 26.8867 47.9795 26.8867C45.1388 26.8865 42.8359 24.583 42.8359 21.7422C42.8361 18.9016 45.1389 16.5988 47.9795 16.5986Z",
    stroke: "#F0F0F0",
    strokeWidth: 3.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11589_6343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1772Plug);
export default __webpack_public_path__ + "static/media/j1772plug.ca86bead92cad47f018a62233a29615b.svg";
export { ForwardRef as ReactComponent };